import {
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { useTranslation } from "react-i18next";
import useWebsiteInfo from "../../hook/useWebsiteInfo";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { HIDE_GAME_PLATFORM_MAINTAIN } from "../../redux/action/member/memberAction";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const GamePlatformMaintainModal = () => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const { images } = useWebsiteInfo();

  const dispatch = useDispatch();
  const isPlatformMaintain = useSelector((state) => state.isPlatformMaintain);

  const handleConfirm = () => {
    dispatch(HIDE_GAME_PLATFORM_MAINTAIN());
  };

  return (
    isPlatformMaintain?.state && (
      <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(0, 0, 0, 0.8)"
        zIndex="9998"
        backdropFilter="blur(2px)"
        justifyContent="center"
        alignItems="center"
      >
        <ChakraBox
          as={Flex}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.3 }}
          w="520px"
          minH="300px"
          bgImage={`url('${images.hintBG}')`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100% 100%"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="space-between"
          position={"relative"}
          p={6}
        >
          <Flex
            fontSize="24px"
            color="white"
            textAlign="center"
            mt={4}
            bgImage={`url('${images.hintTitleBG}')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            sx={{ width: "-webkit-fill-available" }}
            justifyContent="center"
            alignItems="center"
          >
            <Image
              src={images.hintWORD}
              height={{
                base: "50px",
                xl: "60px",
              }}
            />
          </Flex>
          <Box fontSize="24px" color="white" textAlign="center" mb={2}>
            <Text>{i18n_common("以下遊戲平台將進行維護")}：</Text>
            {isPlatformMaintain?.platformList?.map((item, index) => {
              return (
                <Text fontSize="18px">
                  ＊
                  {i18n_common("平台維護通知", {
                    maintainTime: item?.minutes,
                    platform: item?.platform,
                  })}
                </Text>
              );
            })}
            <Text>{i18n_common("請提前離開遊戲，感謝您的配合")}</Text>
          </Box>

          <Flex
            gap={4}
            mb={4}
            justifyContent="space-between"
            alignItems="center"
          >
            <Flex
              as="button"
              w="165px"
              h="62px"
              bgImage={`url('${images.yesBTN}')`}
              bgPosition="center"
              bgRepeat="no-repeat"
              bgSize="100% 100%"
              justifyContent="center"
              alignItems="center"
              onClick={handleConfirm}
            >
              <Image
                src={`${COMMON_WEB_PATH}/FlyDragon/yesWORD${
                  i18next.language == "tw" ? "" : `_${i18next.language}`
                }.webp`}
                width="70px"
                height={{
                  base: "30px",
                  xl: "30px",
                }}
              />
            </Flex>
          </Flex>
        </ChakraBox>
      </Flex>
    )
  );
};

export default GamePlatformMaintainModal;
